import { render, staticRenderFns } from "./Convalidacion.vue?vue&type=template&id=2919ed62&"
import script from "./Convalidacion.vue?vue&type=script&lang=js&"
export * from "./Convalidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports